import { render, staticRenderFns } from "./FrequencyDocumentSaveModalFinish.vue?vue&type=template&id=0132b804&scoped=true"
import script from "./FrequencyDocumentSaveModalFinish.vue?vue&type=script&lang=ts"
export * from "./FrequencyDocumentSaveModalFinish.vue?vue&type=script&lang=ts"
import style0 from "./FrequencyDocumentSaveModalFinish.vue?vue&type=style&index=0&id=0132b804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132b804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0132b804')) {
      api.createRecord('0132b804', component.options)
    } else {
      api.reload('0132b804', component.options)
    }
    module.hot.accept("./FrequencyDocumentSaveModalFinish.vue?vue&type=template&id=0132b804&scoped=true", function () {
      api.rerender('0132b804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencyDocumentSaveModalFinish.vue"
export default component.exports